interface PageHeaderProps {
  label: string;
  title: string;
  subtitle?: string;
}

export default function PageHeader({ label, title, subtitle }: PageHeaderProps) {
  return (
    <div className="bg-primary-600 pt-28 pb-14 md:pt-32 md:pb-20 px-4 md:px-6">
      <div className="max-w-7xl mx-auto text-center">
        <p className="text-accent-300 text-xs tracking-[0.2em] uppercase font-medium mb-3">
          {label}
        </p>
        <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-white leading-tight">
          {title}
        </h1>
        {subtitle && (
          <p className="text-white/70 text-sm md:text-base mt-3 max-w-xl mx-auto">
            {subtitle}
          </p>
        )}
      </div>
    </div>
  );
}